import React from "react"
import { useTranslation } from "react-i18next"

import {
  ProductPositionOverlay,
  ProductPositionOverlayViewModel
} from "../product-position-overlay/ProductPositionOverlay"

export type NewProductPositionOverlayViewModel = Omit<
  ProductPositionOverlayViewModel,
  "id" | "headline"
> & {
  title?: string
}

export const NewProductPositionOverlayView = React.memo(
  (props: NewProductPositionOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <ProductPositionOverlay
        {...props}
        id="new-product-position-overlay"
        className="new-product-position-overlay"
        headline={props.title ?? t("ProductPosition.Actions.Create")}
        prefix="product-position__create"
      />
    )
  }
)
